import type { ClientTaskData, TaskStatus } from '@/types/clientTasksApiTypes';

function unwrapApiPayload(response: unknown): unknown {
  if (typeof response === 'object' && response !== null && 'data' in response) {
    return (response as { data: unknown }).data;
  }

  return response;
}

function isTaskStatus(value: unknown): value is TaskStatus {
  return value === 'OPEN' || value === 'COMPLETED' || value === 'CLOSED';
}

function isClientTaskData(value: unknown): value is ClientTaskData {
  if (typeof value !== 'object' || value === null) return false;

  const record = value as Record<string, unknown>;

  return typeof record.id === 'number' && typeof record.title === 'string' && isTaskStatus(record.status);
}

export function parseCalendarTaskResponse(response: unknown): ClientTaskData | null {
  const payload = unwrapApiPayload(response);
  return isClientTaskData(payload) ? payload : null;
}
